// A team's ban list (the row of micro character avatars).
// Args:
//   @inverted - when truthy adds the 'inverted' modifier to the wrap
//   @bans     - array of { image, alt } for each banned character
<template>
  <div class='ban-list-wrap {{if @inverted "inverted"}}'>
    <p class='ban-list-title'>Team Bans</p>
    <div class='ban-list'>
      {{#each @bans as |ban|}}
        <img class='ban-list-item user-avatar micro' src={{ban.image}} alt={{ban.alt}} />
      {{/each}}
    </div>
  </div>
</template>
